<template>
  <div>

    <div class="row">
      <div class="col-6">
        <i class="ml-2 bi bi-question-circle-fill" title="Alpha diversity (α-diversity) is the mean species diversity in a site at a local scale. Here values are computed using Shannon Index "
           v-bind:style="{ fontSize : '15px'}" v-b-tooltip.hover ></i>
      </div>
      <div class="col-6" v-bind:style="{ width:'100%', textAlign: 'right', paddingRight:'20px' }">
        <i class=" mr-1 bi bi-sliders" data-toogle="tooltip" title="Settings" v-b-modal="componentId+'-modal'"
           v-bind:style="{ fontSize : '15px'}"></i>
        <i class=" mr-1 bi bi-card-text" data-toogle="tooltip" title="Legend" v-bind:style="{fontSize : '15px'}" v-b-modal="componentId+'-legend'"></i>
        <i class="mr-1 bi bi-save-fill" data-toogle="tooltip" title="Export" v-bind:style="{ fontSize : '12px'}"
           v-b-modal="componentId+'-modal-save'"></i>
        <i class=" mr-1 bi bi-files" data-toogle="tooltip" title="Duplicate" v-on:click="cloneCurrentWidget"
           v-bind:style="{ fontSize : '12px'}"></i>
      </div>
    </div>
    <div class="widget-legend legend">
            <span :id="componentId+'plot_title'">Alpha Diversity of {{
                taxon
              }} by {{ this.groupBy}} (in %) on fraction {{ this.fraction }} µm</span>
    </div>
    <AlphaDiversityWidget :plotData="plotData" :componentId="componentId" :advanced="advanced">
    </AlphaDiversityWidget>
    <b-modal :id="componentId+'-modal'" title="Alpha diversity Distribution">
      <div class="form-group mt-2" style="font-size: 1.6vmin;">
        <div class="form-group mt-2">
          <b-form-group label="Grouped by">
            <select v-model="groupBy" class="form-control">
              <option v-for="option in groupByOptions" v-bind:key="option.value" :value="option.value">
                {{ option.text }}
              </option>
            </select>
          </b-form-group>
        </div>
        <div class="form-group mt-2">
          <b-form-group label="Depth">
            <select v-model="depth" class="form-control">
              <option v-for="option in depthCodes" v-bind:key="option.depth" :value="option.depth">
                {{ option.depth }}
              </option>
            </select>
          </b-form-group>
        </div>
        <div class="form-group mt-2" style="font-size: 1.6vmin;">
          <template>
            <b-form-group label="Fraction size" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  :id="componentId+'radio-group-2'"
                  v-model="fraction"
                  :options="fractions"
                  :aria-describedby="ariaDescribedby"
                  name="fraction-options"
              ></b-form-radio-group>
            </b-form-group>
          </template>
        </div>
        <div>
          <b-form-checkbox
              :id="componentId+'advanced'"
              v-model="advanced"
              name="advanced_splitting"
              value="checked"
              unchecked-value="not_checked"
          >
            Advanced Splitting
          </b-form-checkbox>
        </div>
        <div class="form-group mt-2" style="font-size: 1.6vmin;" v-if="advanced === 'checked'">
          <template>
            <b-form-group label="Splitting : " v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  :id="componentId+'radio-group-advanced'"
                  v-model="splitBy"
                  :options="advancedSplittingOptions"
                  :aria-describedby="ariaDescribedby"
                  name="split-options"
              ></b-form-radio-group>
            </b-form-group>
          </template>
        </div>
      </div>
    </b-modal>
    <b-modal :id="componentId+'-legend'" title="Legend">
      HTML allowed
      <textarea class="col-12" v-model="legend" placeholder="add multiple lines"></textarea>

      <b-button v-b-toggle="'collapse'+ componentId" variant="primary">Show/Hide</b-button>
    </b-modal>
    <div>
      <b-collapse v-model="visible" :id="'collapse'+componentId" class="">
        <b-card>
          <div v-html="legend">
          </div>

        </b-card>
      </b-collapse>
    </div>
    <ExportDialog :componentId="componentId" :plotData="plotData" :exportFileName="exportFileName"
                  :dataset="dataset" :formattedData="formattedData" :legend="legend"></ExportDialog>
  </div>
</template>


<script>
import axios from "axios"
import {mapActions} from "vuex"
import {ApiCall} from "../mixins/ApiMixin";
import ExportDialog from "./ExportDialog.vue";
import AlphaDiversityWidget from "./AlphaDiversityWidget.vue";


export default {
  name: "SeasonalGraph",
  props: ['panelId', 'componentId', 'triggerValue', 'settings'],
  mixins: [ApiCall],

  data() {
    return {
      advancedSplittingOptions: [
        {text: 'By Depth', value: 'depth'},
        {text: 'By Year', value: 'year'},
        {text: 'By Cluster', value: 'cluster'},
        {text: 'By Station', value: 'station'},
      ],
      representationOptions: [],
      representation: null,
      groupByOptions: [
        {text: 'Season', value: 'season'},
        {text: 'Year', value: 'year'},
        {text: 'Month', value: 'month'},
        {text: 'Depth', value: 'depth'},
        {text: 'Station', value: 'station'},
        {text: 'Cluster', value: 'cluster'}
      ],
      visible: false,
      groupBy: null,
      dataset: null,
      advanced: "not_checked",
      splitBy: null,
      rank: null,
      searchPanelTaxon: null,
      depth: null,
      depthCodes: {},
      dateStart: null,
      dateEnd: null,
      taxon: null,
      taxons: {},
      fractions: [],
      fraction: null,
      legend: null,
      plotData: null,
      formattedData: null,
      settingsHash: "",
      exportFileName: "mygod_boxplot",
      apiCallsInProgress: 0,
      plot_name: 'season_plot'

    }
  },

  components: {
    AlphaDiversityWidget,
    ExportDialog
  },

  created: function () {
    this.updateContents()
  },


  watch: {

    triggerValue() {
      this.updateContents()
    },
    taxon() {
      this.getPlotData()
    },
    groupBy() {
      this.getPlotData()
    },
    fraction() {
      this.getPlotData()
    },
    depth() {
      this.getPlotData()
    },
    asv() {
      this.getPlotData()
    },
    representation() {
      this.getPlotData()
    },
    advanced() {
      if (this.advanced === 'not_checked') {
        this.splitBy = null
      }
    },
    splitBy() {
      this.getPlotData()
    },
    legend() {
      this.updateDashboardWidgetLegend({
        'componentId': this.componentId,
        'legend': this.legend
      })
    },
    plotData() {
      this.reformatData()
    }
  },

  methods: {

    ...mapActions([
      'updateDashboardWidgetSettings',
      'cloneWidget',
      'updateDashboardWidgetLegend'
    ]),

    updateContents() {
      let panel = this.$store.state.panels[this.panelId]
      let newPanelSettingsHash = panel.dataset + panel.rank + panel.taxon + panel.dateStart + panel.dateEnd
      if (newPanelSettingsHash === this.settingsPanelHash) {
        return
      }
      this.settingsPanelHash = newPanelSettingsHash
      this.plotData = null

      this.dataset = panel.dataset
      this.rank = panel.rank
      this.searchPanelTaxon = panel.taxon
      this.dateStart = panel.dateStart
      this.dateEnd = panel.dateEnd

      this.initializeGroupBy()
      this.initializeSplitBy()
      this.initializeLegend()
      this.initializeRepresentation()
      this.initializeFractionSizes()
      this.initializeDepthCode()
      this.getPlotData()

    },

    getPlotData() {
      if (this.apiCallsInProgress > 0) {
        setTimeout(this.getPlotData, 2000)
        return
      }
      if (this.dataset && this.fraction && this.dateStart && this.dateEnd && this.taxon && this.asv && this.depth && this.groupBy && this.representation) {
        let asvString = this.asv
        let newSettingsHash = this.dataset + this.taxon + asvString + this.fraction + this.dateStart + this.dateEnd + this.depth + this.groupBy + this.representation + this.splitBy
        if (newSettingsHash === this.settingsHash) {
          return
        }
        this.settingsHash = newSettingsHash
        this.plotData = null

        this.updateDashboardWidgetSettings({
          'componentId': this.componentId,
          'settings': {
            'dataset': this.dataset,
            'taxon': this.taxon,
            'asv': this.asv,
            'representation': this.representation,
            'fraction': this.fraction,
            'dateStart': this.dateStart,
            'dateEnd': this.dateEnd,
            'depth': this.depth,
            'groupBy': this.groupBy,
            'splitBy ': this.splitBy,
            'legend': this.legend,
            'advanced': this.advanced

          }
        })


        let me = this
        let taxonSelectValue = this.taxon
        let words = taxonSelectValue.split('@')
        let rank = words[0]
        let taxon = words[1]
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['alpha_diversity', this.dataset,
            rank, taxon, this.fraction, this.dateStart, this.dateEnd, this.groupBy, this.splitBy]))
            .then(function (response) {
              me.plotData = response.data
            })


      } else {
        console.debug("getPlotData() " + this.componentId + ": undefined parameters, no actual data  retrieval attempted.")
      }
    },


  }
}


</script>

<style scoped>
</style>
